import {ClipboardService}                           from "ngx-clipboard";
import {Component, OnInit, OnDestroy, ViewChild,
	Renderer2}                                      from '@angular/core';
import {HttpErrorResponse}                          from "@angular/common/http";
import {NgbDate}                                    from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import {NgbModal, NgbModalOptions}                  from '@ng-bootstrap/ng-bootstrap'
import {Router, NavigationEnd}                                     from "@angular/router";

import {AngularQuery}                               from "../../../services/query/angularquery";
import {Message}                                    from "../../../services/message/message";
import {MessageEntry}                               from "../../../services/message/message-entry";
import {MessageService}                             from "../../../services/message/message.service";
import {NewsFeed}                                   from "../../../services/news/newsfeed";
import {NewsService}                                from "../../../services/news/news-service";
import {NewsViewComponent}                          from "./view/news-view.component";
import {Tag}                                        from '../../../services/tag/tag';
import {TagService}                                 from "../../../services/tag/tag.service";

import {Subscription}                               from "rxjs/Subscription";
import {isNullOrUndefined}                          from "util";
import {sprintf}                                    from "sprintf-js";


@Component({
	selector: 'app-news',
	templateUrl: './news.component.html',
	styleUrls: ['./news.component.css']
})


/**
 * Display a calendar, let the user pick some days
 * and then display NFL player news for that
 * date range.
 *
 */
export class NewsComponent implements OnInit, OnDestroy {

	fromDate:string;
	message: Message;
	newsSubscription:Subscription;
	stories:NewsFeed[] = [];
	subscription: Subscription;
	toDate:string;
	sportId: number = 6;

	checkboxes: Tag[] = []
	checkboxSubscription: Subscription;     // The Subscription for the checkbox Tag service.

	// ROUTER variables.
	navigationSubscription: Subscription;   // Allows reloading of same page.


	/**
	 * Create the object and set up what it needs to talk to.
	 *
	 * @param clipboardService Allows storage of text into the clipboard.
	 * @param messageService   Handles communication with the message bar.
	 * @param modalService     The service that allows the edit modal to appear.
	 * @param newsService      The service the retrieves the articles for display on the popup.
	 * @param renderer         The Renderer object needed to make the clipboard copy work.
	 * @param router           The Router singleton used for navigation.
	 */
	constructor(

		private clipboardService: ClipboardService,
		private messageService: MessageService,
        private modalService: NgbModal,
        private newsService: NewsService,
		private tagService: TagService,
        private renderer: Renderer2,
        private router: Router,

	) {
		// Support reload of page; this fires every time the Router completes its process.
		this.navigationSubscription = this.router.events.subscribe((e: any) => {

			// Retrieve and display the appropriate information.
			if (e instanceof NavigationEnd) {
				this.initializeCheckboxes();
			}

		});
	}


	/**
	 * Unsubscribe to the subscriptions to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.newsSubscription) {
			this.newsSubscription.unsubscribe();
		}

		if (this.subscription) {
			this.subscription.unsubscribe();
		}

		if (this.checkboxSubscription) {
			this.checkboxSubscription.unsubscribe();
		}

	}


	/**
	 * Set up communications with the message service.
	 */
	ngOnInit() {

		// Set up communications with the MessageService.
		this.subscription = this.messageService.subject.subscribe( message => { this.message = message; } );

		// Notify the user initialization is complete. This is a HACK! It has to be sent in the next Angular 'tick' to avoid an error message.
		setTimeout(()=>{
			this.messageService.sendMessageEntry(new MessageEntry({

				message: 'Ready',
				level: 1

			}));
		}, 0);

	}


	/**
	 * Lets me talk to the 'From' datepicker.
	 */
	@ViewChild('from')
	from: any;


	/**
	 * Lets me talk to the 'To' datepicker.
	 */
	@ViewChild('to')
	to: any;


	/**
	 * Reproduce the information displayed in the preview window
	 * and save it to the computer clipboard.
	 */
	copyToClipboard(): void {

		let content:string = '<html>\r\n<head>\r\n<title>News Daily Email Results</title>\r\n<meta http-equiv="Content-Type" content="text/html; charset=utf-8">\r\n</head>\r\n<body bgcolor="#FFFFFF">\r\n';

		for (let story of this.stories) {

			content += sprintf('<strong>%s %s - %s, %s</strong>\r\n<br />\r\n<br />\r\n%s<br />\r\n<br />\r\nHUDDLE UP: %s', story.firstname, story.surname, story.poscode, story.team, story.body, story.fantasy_tip);
			content += '<br />\r\n<hr noshade="noshade" style="border: 0; height: 1px; background-color: #dddddd; margin-top:1em; margin-bottom:1em;" />\r\n';

		}

		content += '</body>\r\n</html>\r\n';
		this.clipboardService.copyFromContent(content);

	}

	/**
	 * Pop up the stories page based on the selected dates.
	 */
	displayStories(): void {

		let opts:NgbModalOptions = {

			'size': "lg"

		};

		let title:string = 'NFL Player Stories for ';

		if (isNullOrUndefined(this.toDate) || this.fromDate === this.toDate) {

			title += this.fromDate;

		} else {

			title += this.fromDate + ' to ' + this.toDate;

		}

		const modalRef = this.modalService.open(NewsViewComponent, opts);
		modalRef.componentInstance.windowTitle = title;
		modalRef.componentInstance.stories = this.stories;

		// See if the user wanted a copy of the text saved to their clipboard.
		modalRef.result.then((result) => {

			if (! isNullOrUndefined(result) && 'clipboard' === result) {

				this.copyToClipboard();

			}

		});

	}


	/**
	 * Retrieve the stories to display.  If there are no
	 * errors, pop up the display window for them.
	 */
	retrieveStories():void {

		this.setFromDate(this.from.selectedDate);
		this.setToDate(this.to.selectedDate);

		this.messageService.sendMessageEntry(new MessageEntry({

			message: 'Ready',
			level: 1

		}));

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_NFL_PLAYER_NEWS);
		query.addParameter('fromDate', this.fromDate);
		query.addParameter('toDate', this.toDate);

		const tags = this.checkboxes.filter(item => item.checked === 1).map(item => item.tag).join(',');

		query.addParameter('tags', tags);

		// Retrieve the articles.
		this.newsSubscription = this.newsService.getNewsFeedItems(query.getUrl()).subscribe(

			(response) => {

				this.stories = response;
				this.messageService.sendMessageEntry(new MessageEntry({

					message: 'Stories retrieved for display',
					level: 1

				}));
				this.displayStories();

			},

			(error) => {

				this.stories = [];

				if (error instanceof HttpErrorResponse) {

					if (404 !== error.status) {

						this.messageService.sendMessageEntry(new MessageEntry({

							message: 'Couldn\'t retrieve story list for display due to database error',
							level: 4

						}));

					} else {

						this.messageService.sendMessageEntry(new MessageEntry({

							message: 'No stories available for display in the requested date range',
							level: 2

						}));

					}

				}

			}

		);

	}

	/**
	 * Allows the date picker child component
	 * to set the from date in this component.
	 *
	 * @param {NgbDate} choice  The year/month/day from the date picker, or null.
	 */
	setFromDate(choice:NgbDate): void {

		if (isNullOrUndefined(choice)) {

			this.fromDate = null;

		} else {

			let month:string = (9 < choice.month) ? String(choice.month) : '0' + String(choice.month);
			let day:string = (9 < choice.day) ? String(choice.day) : '0' + String(choice.day);
			this.fromDate = choice.year + '-' + month + '-' + day;

		}

	}


	/**
	 * Allows the date picker child component
	 * to set the to date in this component.
	 *
	 * @param {NgbDate} choice  The year/month/day from the date picker, or null.
	 */
	setToDate(choice:NgbDate): void {

		if (isNullOrUndefined(choice)) {

			this.toDate = null;

		} else {

			let month:string = (9 < choice.month) ? String(choice.month) : '0' + String(choice.month);
			let day:string = (9 < choice.day) ? String(choice.day) : '0' + String(choice.day);
			this.toDate = choice.year + '-' + month + '-' + day;

		}

	}

	/**
	 * Switch back to the story list.
	 *
	 */
	viewStoryList(): void {

		this.router.navigate(['/articles/list']);

	}

	listCheckboxTags(): Tag[] {

		let checkboxList: Tag[] = [];

		if (!isNullOrUndefined(this.checkboxes)) {

			for (let tag of this.checkboxes) {

				if (true === tag.sport_checkbox) {

					checkboxList.push(tag);

				}

			}

		}

		return checkboxList;

	}

	/**
	 * Retrieve the Sport checkbox tags for this article and initialize the display.
	 */
	initializeCheckboxes(): void {

		this.checkboxSubscription = this.tagService.getCheckboxes(this.sportId).subscribe(

			(tags) => {
				this.checkboxes = tags.map(item => ({
					...item,
					checked: item.tag === 'huddle' ? 1 : 0,
					sport_checkbox: true,
				}))
			},

			(error) => {

				this.checkboxes = [];

				if (error instanceof HttpErrorResponse && 404 !== error.status) {
					this.messageService.sendMessageEntry(new MessageEntry({
						message: 'Failed to retrieve checkbox information due to server error',
						level: 4
					}));
				}

			},
		);

	}
	
	/**
	 * Convert the user's click on a tag to the appropriate
	 * value in the tag.checked property.
	 *
	 * @param {any} $event  Usually a mouse click on a checkbox.
	 */
	tagClick($event: any): void {
		$event.cancelBubble = true;

		for (let checkbox of this.checkboxes) {

			if ($event.srcElement.dataset['id'] == checkbox.id) {

				checkbox.checked = ($event.srcElement.checked) ? 1 : 0;
				break;

			}

		}

	}

}



// WEBPACK FOOTER //
// ./src/app/articles/feed/news/news.component.ts